import { HttpHeaders } from "../../../api/types"
import { createGraphQLRequest } from "../../../api/utils/httpRequest"
import { PreparedImageUploadResponse, QueryPrepareImageUploadArgs } from "../../../graphql/types"

export const prepareImageUrlRequest = (
    headers: HttpHeaders,
    args: QueryPrepareImageUploadArgs
): Promise<PreparedImageUploadResponse> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query prepareImageUpload($filename: String!, $fileType: String!) {
                    prepareImageUpload(filename: $filename, fileType: $fileType) {
                        signedRequest
                        url
                    }
                }
            `,
            operationName: "prepareImageUpload",
            variables: args,
        },
    }).then(response => {
        const data = response?.data?.prepareImageUpload
        if (!data) {
            throw new Error("prepareImageUrlRequest - no data")
        }
        return data
    })
